export const CERTIFICATE_LABELS = {
  // ─── Page / nav ───────────────────────────────────────────────────────────────
  PAGE_TITLE: 'Certyfikaty',
  TAB_TEMPLATES: 'Szablony',
  TAB_CERTIFICATES: 'Certyfikaty',

  BUTTON_CREATE_TEMPLATE: 'Dodaj szablon certyfikatu',

  LIST_SEARCH_PLACEHOLDER: 'Szukaj po ID szablonu',

  LIST_COL_CREATED_AT: 'Data utworzenia',
  LIST_COL_CERTIFICATE_NAME: 'Nazwa szablonu',
  LIST_COL_TEMPLATE_ID: 'Template ID',
  LIST_COL_TASK_FORM_ID: 'Task Form ID',
  LIST_COL_TASK_FORM_NAME: 'Formularz zadania',
  LIST_COL_ACTIONS: 'Akcje',

  LIST_ACTION_VIEW: 'Podgląd',
  LIST_ACTION_EDIT: 'Edytuj',
  EMPTY_STATE_TITLE: 'Brak dostępnych szablonów certyfikatów.',
  EMPTY_STATE_DESCRIPTION:
    'Skonfiguruj szablony certyfikatów, aby usprawnić proces certyfikacji.',
  NO_RESULTS_TITLE: 'Nie znaleziono wyników.',
  NO_RESULTS_DESCRIPTION_SEARCH: 'Spróbuj zmienić kryteria wyszukiwania.',
  NO_RESULTS_DESCRIPTION_FILTER: 'Spróbuj zmienić zastosowane filtry.',
  NO_RESULTS_DESCRIPTION_BOTH:
    'Spróbuj zmienić kryteria wyszukiwania lub zastosowane filtry.',
  CERTIFICATES_TAB_EMPTY_TITLE: 'Brak dostępnych certyfikatów.',
  CERTIFICATES_TAB_EMPTY_DESCRIPTION:
    'Wystawione certyfikaty pojawią się tutaj.',

  // ─── View page ────────────────────────────────────────────────────────────────
  VIEW_PAGE_TITLE: 'View Certificate Template',
  VIEW_BUTTON_EDIT: 'Edytuj szablon certyfikatu',
  VIEW_DETAILS_TITLE: 'Certificate Template Details',
  VIEW_FIELD_TEMPLATE_ID: 'Template ID',
  VIEW_FIELD_TASK_FORM: 'Formularz zadania',
  VIEW_FIELD_TASK_FORM_ID: 'Task Form ID',
  VIEW_FIELD_CREATED_DATE: 'Data utworzenia',
  VIEW_VALUE_EMPTY: '—',
  VIEW_ERROR_GENERIC: 'Nie udało się załadować szablonu certyfikatu.',

  // ─── Create page ──────────────────────────────────────────────────────────────
  /** EN: "Create certificate template" */
  CREATE_TITLE: 'Utwórz szablon certyfikatu',
  /** EN: "Preview" */
  PREVIEW_TITLE: 'Podgląd',

  // ─── Form fields ─────────────────────────────────────────────────────────────
  /** EN: "Template name" */
  FIELD_TEMPLATE_NAME: 'Nazwa szablonu',
  /** EN: "Select a task form" */
  FIELD_FORM_SELECT: 'Wybierz formularz zadania',
  /** EN: "Certificate data" */
  SECTION_CERTIFICATE_DATA: 'Dane certyfikatu',
  /** EN: "Enter basic identifying information and context to help technicians recognise and understand the purpose of this form." */
  SECTION_CERTIFICATE_DATA_DESC:
    'Podaj podstawowe informacje identyfikacyjne i kontekst, aby pomóc technikom rozpoznać i zrozumieć przeznaczenie tego formularza.',
  /** EN: "Header" */
  FIELD_HEADER: 'Nagłówek',
  /** EN: "Footer text" */
  FIELD_FOOTER: 'Tekst stopki',
  /** EN: "Subtitle (Optional)" */
  FIELD_SUBTITLE: 'Podtytuł (Optional)',

  // ─── Checkboxes ───────────────────────────────────────────────────────────────
  /** EN: "Data will be automatically fetched from service requests" */
  AUTO_DATA_SECTION:
    'Dane zostaną automatycznie pobrane ze zgłoszeń serwisowych',
  /** EN: "Include client, facility and equipment data" */
  CHECK_CLIENT_FACILITY: 'Uwzględnij dane klienta, placówki i aparatury',
  /** EN: "Include service request data" */
  CHECK_SERVICE_REQUEST: 'Uwzględnij dane zgłoszenia serwisowego',
  /** EN: "Include assigned technician data" */
  CHECK_TECHNICIAN: 'Uwzględnij dane przypisanego technika',

  // ─── Field selection ──────────────────────────────────────────────────────────
  /** EN: "Task form fields" */
  SECTION_FORM_FIELDS: 'Pola formularza zadania',
  /** EN: "Select the fields from the form that should be visible in the certificate." */
  SECTION_FORM_FIELDS_DESC:
    'Wybierz pola z formularza, które mają być widoczne w certyfikacie.',
  /** EN: "Select a task form first." */
  FIELD_SELECTION_PLACEHOLDER: 'Najpierw wybierz formularz zadania.',
  /** EN: "This form has no fields." */
  FIELD_SELECTION_NO_FIELDS: 'Ten formularz nie ma pól.',
  // ─── Buttons ──────────────────────────────────────────────────────────────────
  /** EN: "Cancel" */
  BUTTON_CANCEL: 'Anuluj',
  /** EN: "Preview" */
  BUTTON_PREVIEW: 'Podgląd',
  /** EN: "Save" */
  BUTTON_SAVE: 'Zapisz',
  /** EN: "Saving..." */
  BUTTON_SAVING: 'Zapisywanie...',
  /** EN: "Back" (from preview back to edit) */
  BUTTON_BACK: 'Anuluj',

  // ─── Edit page ────────────────────────────────────────────────────────────────
  /** EN: "Edit certificate template" */
  EDIT_TITLE: 'Edytuj szablon certyfikatu',
  /** "Template ID" (disabled field on edit screen) */
  FIELD_TEMPLATE_ID: 'Template ID',
  /** "Task Form ID" (disabled field on edit screen) */
  FIELD_TASK_FORM_ID: 'Task Form ID',

  // ─── Success / error feedback ─────────────────────────────────────────────────
  CREATE_SUCCESS: 'Certificate template added successfully.',
  EDIT_SUCCESS: 'Certificate template updated successfully.',

  // ─── Validation errors ────────────────────────────────────────────────────────
  ERROR_TEMPLATE_NAME_REQUIRED: 'To pole jest wymagane.',
  ERROR_TEMPLATE_NAME_MAX: 'Nazwa szablonu może mieć maksymalnie 200 znaków.',
  ERROR_FORM_REQUIRED: 'To pole jest wymagane.',
  ERROR_HEADER_REQUIRED: 'To pole jest wymagane.',
  ERROR_HEADER_MAX: 'Nagłówek może mieć maksymalnie 200 znaków.',
  ERROR_FOOTER_REQUIRED: 'To pole jest wymagane.',
  ERROR_FOOTER_MAX: 'Tekst stopki może mieć maksymalnie 200 znaków.',
  ERROR_SUBTITLE_MAX: 'Podtytuł może mieć maksymalnie 500 znaków.',
  /** EN: "Select at least one additional field to proceed, apart from the preselected ones." */
  ERROR_FIELDS_REQUIRED:
    'Wybierz co najmniej jedno dodatkowe pole, oprócz wstępnie zaznaczonych, aby kontynuować.',

  // ─── Moje certyfikaty (Technician list page) ─────────────────────────────────
  MY_CERTS_PAGE_TITLE: 'Certyfikaty',
  MY_CERTS_EMPTY_TITLE: 'Brak certyfikatów.',
  MY_CERTS_EMPTY_DESCRIPTION:
    'Certyfikaty wygenerowane z ukończonych zadań serwisowych pojawią się w tym miejscu.',
  MY_CERTS_NO_RESULTS_TITLE: 'Brak wyników.',
  MY_CERTS_NO_RESULTS_DESC_SEARCH: 'Spróbuj zmienić kryteria wyszukiwania.',
  MY_CERTS_NO_RESULTS_DESC_FILTER: 'Spróbuj zmienić ustawienia filtrów.',
  MY_CERTS_NO_RESULTS_DESC_BOTH:
    'Spróbuj zmienić kryteria wyszukiwania lub filtry.',
  MY_CERTS_FILTER_FACILITY_LABEL: 'Placówka',
  MY_CERTS_FILTER_FACILITY_PLACEHOLDER: 'Wybierz placówkę',
  MY_CERTS_FILTER_BUTTON: 'Filtruj',
  MY_CERTS_CARD_SR_ID: 'ID zgłoszenia',
  MY_CERTS_CARD_CLIENT: 'Klient',
  MY_CERTS_CARD_FACILITY: 'Placówka',
  MY_CERTS_CARD_EQUIPMENT: 'Urządzenie',
  MY_CERTS_CARD_SERVICE_TYPE: 'Typ usługi',
  MY_CERTS_CARD_GENERATED_AT: 'Data wygenerowania',
  MY_CERTS_CARD_DOWNLOAD: 'Pobierz PDF',
  MY_CERTS_CARD_DOWNLOADING: 'Pobieranie...',
  MY_CERTS_CARD_DOWNLOAD_ERROR: 'Nie można pobrać. Spróbuj ponownie.',
  MY_CERTS_FETCH_ERROR:
    'Nie udało się załadować certyfikatów. Spróbuj ponownie.',

  // ─── Certyfikaty tab (admin CertificateList page) ─────────────────────────
  CERTS_TAB_SEARCH_PLACEHOLDER: 'Szukaj po ID certyfikatu',
  CERTS_TAB_EXPORT_BUTTON: 'Eksportuj',
  // Base text for the animated in-progress snackbar — the trailing "."/".."/"..."
  // is appended and cycled by MyCertificates (matches Figma's 3-frame loading animation).
  CERTS_TAB_EXPORTING: 'Eksportowanie listy certyfikatów',
  CERTS_TAB_EXPORT_SUCCESS:
    'Lista certyfikatów została pomyślnie wyeksportowana.',
  CERTS_TAB_EXPORT_ERROR:
    'Nie udało się wyeksportować listy certyfikatów. Spróbuj ponownie.',
  CERTS_TAB_EXPORT_EMPTY:
    'Brak certyfikatów do wyeksportowania dla wybranych kryteriów wyszukiwania lub filtrów.',
  CERTS_TAB_FILTER_BUTTON: 'Filtruj',
  CERTS_TAB_FILTER_FACILITY_LABEL: 'Placówka',
  CERTS_TAB_FILTER_FACILITY_PLACEHOLDER: 'Wybierz placówkę',
  CERTS_TAB_FILTER_EQUIPMENT_LABEL: 'Nazwa aparatury',
  CERTS_TAB_FILTER_TECHNICIAN_LABEL: 'Imię i nazwisko technika',
  CERTS_TAB_CARD_EQUIPMENT_LABEL: 'APARATURA',
  CERTS_TAB_CARD_SR_LABEL: 'ZGŁOSZENIE SERWISOWE',
  CERTS_TAB_CARD_DATE_LABEL: 'DATA WYDANIA',
  CERTS_TAB_CARD_VIEW: 'Podgląd',
  CERTS_TAB_CARD_DOWNLOAD: 'Pobierz PDF',
  // Table columns (admin/super-admin certificates table)
  CERTS_TAB_COL_CERT_ID: 'ID certyfikatu',
  CERTS_TAB_COL_EQUIPMENT_ID: 'ID aparatury',
  CERTS_TAB_COL_EQUIPMENT_NAME: 'Nazwa aparatury',
  CERTS_TAB_COL_SR_ID: 'ID zgłoszenia serwisowego',
  CERTS_TAB_COL_SR_NAME: 'Nazwa zgłoszenia serwisowego',
  CERTS_TAB_COL_ISSUE_DATE: 'Data wydania',
  CERTS_TAB_COL_TECHNICIAN: 'Imię i nazwisko technika',
  CERTS_TAB_COL_ACTIONS: 'Actions',
  CERTS_TAB_EMPTY_TITLE: 'Brak certyfikatów.',
  CERTS_TAB_EMPTY_DESC:
    'Wystawione certyfikaty pojawią się tutaj po zakończeniu zleceń serwisowych.',
  CERTS_TAB_NO_RESULTS_TITLE: 'Nie znaleziono wyników.',
  CERTS_TAB_NO_RESULTS_DESC:
    'Spróbuj zmienić kryteria wyszukiwania lub zastosowane filtry.',

  // ─── Client certificate tab (ViewClientCertificates) ─────────────────────────
  CLIENT_CERTS_FILTER_EQUIPMENT_LABEL: 'Nazwa aparatury',
  CLIENT_CERTS_FILTER_EQUIPMENT_PLACEHOLDER: 'Nazwa aparatury',
  CLIENT_CERTS_FILTER_TECHNICIAN_LABEL: 'Imię i nazwisko technika',
  CLIENT_CERTS_FILTER_TECHNICIAN_PLACEHOLDER: 'Imię i nazwisko technika',

  // ─── View certificate (technician detail page) ───────────────────────────────
  VIEW_CERT_BREADCRUMB_LIST: 'Certyfikaty',
  VIEW_CERT_BREADCRUMB_DETAIL: 'Podgląd certyfikatu',
  VIEW_CERT_PAGE_TITLE: 'Podgląd certyfikatu',
  VIEW_CERT_DOWNLOAD_BUTTON: 'Pobierz certyfikat',
  VIEW_CERT_DOWNLOADING: 'Pobieranie...',
  VIEW_CERT_DOWNLOAD_NO_PERMISSION:
    'Nie masz uprawnień do pobrania certyfikatu. Skontaktuj się z administratorem.',
  VIEW_CERT_DOWNLOAD_ERROR: 'Nie można pobrać certyfikatu. Spróbuj ponownie.',
  VIEW_CERT_DOWNLOAD_SUCCESS: 'Certyfikat został pomyślnie pobrany.',
  VIEW_CERT_DETAILS_TITLE: 'Certificate Details',
  VIEW_CERT_FIELD_SR_ID: 'ID zgłoszenia serwisowego',
  VIEW_CERT_FIELD_SR_NAME: 'Nazwa zgłoszenia serwisowego',
  VIEW_CERT_FIELD_FORM_ID: 'ID formularza zadania',
  VIEW_CERT_FIELD_FORM_NAME: 'Nazwa formularza zadania',
  VIEW_CERT_FETCH_ERROR:
    'Nie udało się załadować certyfikatu. Spróbuj ponownie.',

  // ─── Cancel modal ─────────────────────────────────────────────────────────────
  CANCEL_MODAL_TITLE: 'Czy na pewno chcesz anulować?',
  CANCEL_MODAL_DESC: 'Wszystkie niezapisane dane zostaną utracone.',
  CANCEL_MODAL_CONFIRM: 'Tak, anuluj',
  CANCEL_MODAL_BACK: 'Wróć',
} as const;

export const CERTIFICATE_PREVIEW_LABELS = {
  SUBTITLE_DEFAULT:
    'This is to certify that the service request for the below-mentioned equipment has been successfully completed as per the required standards and guidelines.',
  CLIENT_NAME_PLACEHOLDER: 'SummitCare Medical Solutions (CLIENT0000001)',
  CLIENT_EMAIL_PLACEHOLDER: 'SummitCare@gmail.com',
  CLIENT_PHONE_PLACEHOLDER: '+48 2838839883',
  FACILITY_NAME_PLACEHOLDER: 'SummitCare Outpatient Clinic (FAC0001)',
  FACILITY_ADDRESS_PLACEHOLDER:
    'ul. Marszałkowska 10, Warszawa, Mazowieckie,\n Poland - 00-024',
  DATE_OF_ISSUE_LABEL: 'Data Wydania',
  DATE_OF_ISSUE_PLACEHOLDER: 'YYYY/MM/DD',

  SR_SECTION_TITLE: 'Szczegóły zgłoszenia serwisowego',
  SR_FIELD_ID: 'ID zgłoszenia',
  SR_FIELD_TYPE: 'Typ usługi',

  FORM_SECTION_TITLE: 'Szczegóły formularza',
  SR_FIELD_FORM_ID: 'ID formularza zadania',
  SR_FIELD_FORM_NAME: 'Nazwa formularza zadania',

  EQUIPMENT_SECTION_TITLE: 'Aparatura',
  EQUIPMENT_FIELD_NAME: 'Nazwa aparatury',
  EQUIPMENT_FIELD_ID: 'ID aparatury',
  EQUIPMENT_FIELD_MODEL: 'Nazwa modelu',
  EQUIPMENT_FIELD_SERIAL: 'Numer seryjny',
  EQUIPMENT_FIELD_PRODUCTION_DATE: 'Data produkcji',
  EQUIPMENT_FIELD_TYPE: 'Typ urządzenia',
  EQUIPMENT_FIELD_SERVICE_TYPE: 'Typ usługi',
  EQUIPMENT_VALUE_PLACEHOLDER: (label: string) => `[${label}]`,

  TECHNICIAN_SIGNATURE: 'Podpis technika',
  TECHNICIAN_DETAILS_PLACEHOLDER: 'Jan Kowalski (TECH00000110)',
  CLIENT_SIGNATURE: 'Podpis klienta',
} as const;
